import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    region: [],
    state: [],
    state_office: [],
    Product_Line: [],
    lob: [],
  },
  submitted: 0,
};

const PowerDeckfilterSlice = createSlice({
  name: "PowerDeckfilter",
  initialState,
  reducers: {
    addFilters(state, action) {
      state.data = action.payload.data;
      state.submitted = action.payload.submitted;
      // state.fmsNav = action.payload.fmsNav;
    },
    applyFilters(state, action) {
      state.data = action.payload;
    },
    chgSubmitted(state, action) {
      state.submitted = action.payload;
    },
    resetFilters(state) {
      state.data = initialState.data;
      state.submitted = initialState.submitted;
    },
  },
});

export const { addFilters, applyFilters, chgSubmitted, resetFilters } =
  PowerDeckfilterSlice.actions;

export default PowerDeckfilterSlice.reducer;
